import React, { useState, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import ReactToPrint, { useReactToPrint } from "react-to-print";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

// import JS files
import useFetch from "../../../../context/useFetch";
import { fixNumbers } from "../../../../utils";
import MuiButton from "../../../shares/MuiButton";
import { useUserData } from "../../../../context/UserDataContext";

const ProviderPrintGeneralOrderByBangle = () => {
  const navigate = useNavigate();
  const { userData } = useUserData();
  const [ringsList, setRingsList] = useState({ results: [] });
  const { unique_id, bangle_name, brand, status, zero_status } = useParams();
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 15000,
    count: 0,
    next: null,
    previous: null,
  });
  const getRingsApi = useFetch({
    method: "get",
    url: `User_Service/${userData.username}/provider_get_bangle_from_order_item_onprogress`,
    pagination: pagination,
    params: {
      code: unique_id == "null" ? null : fixNumbers(unique_id),
      brand: brand == "null" ? null : brand,
      name: bangle_name == "null" ? null : bangle_name,
      order_item_status: status == "null" ? null : status,
      zero_diff: zero_status == "null" ? null : zero_status,
    },

    trigger: true,
    setter: setRingsList,
    argFunc: (res) => {},
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });
  const componentRef = useRef();
  const closeTab = () => {
    window.opener = null;
    window.open("", "_self");
    window.close();
  };
  return (
    <>
      <div className="my-4">
        <div className="flex justify-between items-center mx-8 mb-4">
          <span className="text-sm">برای دانلود فایل PDF کلیک کنید.</span>
          <div className="flex">
            <ReactToPrint
              trigger={() => {
                return (
                  <MuiButton
                    variant="contained"
                    color="primary"
                    text="دانلود فایل PDF"
                    size="small"
                    //    icon={<ModeEditIcon />}
                  />
                );
              }}
              content={() => componentRef.current}
            />
            <div className="mr-4">
              <MuiButton
                onClick={() => closeTab()}
                variant="outlined"
                color="secondary"
                text="بازگشت"
                size="small"
                icon={<ArrowBackIcon />}
              />
            </div>
          </div>
        </div>
        <div
          className="printTable"
          ref={componentRef}
          style={{ direction: "rtl" }}
        >
          <div className=" bg-myblue-100 px-8 py-4 text-center">
            <span className="font-bold text-yellow-200 text-lg">
              فروشگاه زرسان
            </span>
          </div>
          <div className="text-center mt-8">
            <span className="font-bold">سفارش های جاری براساس النگو</span>
          </div>
          <div className="border rounded-md mt-4 overflow-hidden mx-2">
            <div className="flex justify-between">
              <div className="basis-1/2  text-center py-1 ">
                <span className="text-sm text-myblue-100">ردیف</span>
              </div>

              <div className="basis-1/2  text-center py-1 border-r ">
                <span className="text-sm text-myblue-100">برند</span>
              </div>

              <div className="basis-1/2  text-center py-1 border-r ">
                <span className="text-sm text-myblue-100">سن</span>
              </div>
              <div className="basis-1/2  text-center py-1 border-r ">
                <span className="text-sm text-myblue-100">رنگ</span>
              </div>
              <div className="basis-1/2  text-center py-1 border-r ">
                <span className="text-sm text-myblue-100">النگو</span>
              </div>

              <div className="basis-1/2  text-center py-1 border-r ">
                <span className="text-sm text-myblue-100"> وزن</span>
              </div>
              <div className="basis-1/2  text-center py-1 border-r ">
                <span className="text-sm text-myblue-100"> ج1</span>
              </div>
              <div className="basis-1/2  text-center py-1 border-r ">
                <span className="text-sm text-myblue-100"> ج2</span>
              </div>
              <div className="basis-1/2  text-center py-1 border-r ">
                <span className="text-sm text-myblue-100"> ج3</span>
              </div>
              <div className="basis-1/2  text-center py-1 border-r ">
                <span className="text-sm text-myblue-100"> ج4</span>
              </div>
              <div className="basis-1/2  text-center py-1 border-r ">
                <span className="text-sm text-myblue-100"> ج5</span>
              </div>
              <div className="basis-1/2  text-center py-1 border-r ">
                <span className="text-sm text-myblue-100"> ج6</span>
              </div>
            </div>
          </div>

          {ringsList.results.map((item, index) => {
            return [
              <>
                <div className="border rounded-md overflow-hidden mx-2">
                  <div className="flex justify-between">
                    <div className="basis-1/2  text-center py-1  border-r">
                      <span className="text-sm text-gray-700">{index + 1}</span>
                    </div>

                    <div className="basis-1/2  text-center py-1 border-r ">
                      <span className="text-sm text-myblue-100">
                        {item.brand_name}
                      </span>
                    </div>
                    <div className="basis-1/2  border-t text-center py-1 border-r ">
                      <span className="text-sm text-myblue-100">
                        {item.gender == "woman" ? "زنانه" : "بچه گانه"}
                      </span>
                    </div>
                    <div className="basis-1/2  border-t text-center py-1 border-r ">
                      <span className="text-sm text-myblue-100">
                        {item.color == "yellow" ? "زرد" : "سفید"}
                      </span>
                    </div>

                    <div className="basis-1/2  text-center py-1 border-r ">
                      <span className="text-sm text-myblue-100">
                        {item.show_name}
                      </span>
                    </div>

                    <div className="basis-1/2  text-center py-1 border-r ">
                      <span className="text-sm text-myblue-100">
                        {item.total}
                      </span>
                    </div>
                    <div className="basis-1/2  text-center py-1 border-r ">
                      <span className="text-sm text-myblue-100">
                        {item.count_sizes.table_diff_size_one_num}
                      </span>
                    </div>

                    <div className="basis-1/2  text-center py-1 border-r ">
                      <span className="text-sm text-myblue-100">
                        {item.count_sizes.table_diff_size_two_num}
                      </span>
                    </div>

                    <div className="basis-1/2  text-center py-1 border-r ">
                      <span className="text-sm text-myblue-100">
                        {item.count_sizes.table_diff_size_three_num}
                      </span>
                    </div>

                    <div className="basis-1/2  text-center py-1 border-r ">
                      <span className="text-sm text-myblue-100">
                        {item.count_sizes.table_diff_size_four_num}
                      </span>
                    </div>

                    <div className="basis-1/2  text-center py-1 border-r ">
                      <span className="text-sm text-myblue-100">
                        {item.count_sizes.table_diff_size_five_num}
                      </span>
                    </div>
                    <div className="basis-1/2  text-center py-1 border-r ">
                      <span className="text-sm text-myblue-100">
                        {item.count_sizes.table_diff_size_six_num}
                      </span>
                    </div>
                  </div>
                </div>
              </>,
            ];
          })}
        </div>
      </div>
    </>
  );
};

export default ProviderPrintGeneralOrderByBangle;
